import moment from 'moment-timezone';
import React from 'react';
import utils from '../../../services/utils';
import BackButton from '../../Buttons/BackButton/BackButton';
import Button from '../../Buttons/Button/Button';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import Tags from '../../Tags/Tags';
import BankAccounts from '../DetailsPayProcess/BankAccounts/BankAccounts';
import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';

import classes from './DetailPaymentHistory.module.scss';
import { documentTypesAbbreviationsObject } from '../../../store/catalogs/documentTypes';

const DetailPaymentHistory = ({ downloadFile, payment, backView }) => {
  return (
    <div className={classes.detail}>
      <BackButton onClick={backView} />
      <span className={`bold-20 ${classes.title}`}>Detalles de abono realizado</span>
      <span className='semibold-18'>Información del pago</span>
      <div className={classes.fields}>
        <FieldBold title='TIPO DE PAGO'>
          <Tags
            text={payment.totalValueWasPayed ? 'Pago total' : 'Pago parcial'}
            type={payment.totalValueWasPayed ? 'green' : 'gray'}
          />
        </FieldBold>
        <FieldBold title='FECHA Y HORA INICIO DE PAGO' value={moment(payment.date).format('DD/MM/YYYY[,] hh:mm a')} />
        <FieldBold title='MONTO PAGADO' value={utils.moneyFormat(payment.payedValue)} />
      </div>
      <BankAccounts
        methodForPay={payment.payMethod}
        accountsBanks={{
          ...payment,
          sourceAccounts:
            payment.payMethod === 'PSEPay'
              ? [
                  {
                    sourceBankDruoId: 'PSE',
                    name: payment.psePayment.name,
                    identification: `${documentTypesAbbreviationsObject[payment.psePayment.identificationType]} ${
                      payment.psePayment.identificationNumber
                    }`
                  }
                ]
              : payment.druoPayments
        }}
      />
      <div className={classes.button}>
        <Button onClick={downloadFile} Icon={ArrowDownLine}>
          Descargar comprobante
        </Button>
      </div>
    </div>
  );
};

export default DetailPaymentHistory;
